<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbToDlg_styleComponentAnimation()">
		<template v-if="$_mbToDlg_stateComponentIsInitialized">
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							:color="isFalse(messageState_.toUid) ? 'secondary' : 'primary'"
							dark
							icon
							v-on="on"
							@click="$_mbToDlg_open()">
						<v-icon>person</v-icon>
					</v-btn>
				</template>
				<template v-if="!isFalse(messageState_.toUid)">
					<span v-text="messageState_.toName" />
				</template>
				<template v-else>
					Not Set
				</template>
				<v-dialog
						v-model="show_"
						max-width="600px"
						persistent>
					<v-card>
						<v-card-title>To</v-card-title>
						<v-card-text>
							<v-text-field
									hide-details
									outlined
									readonly
									v-model="messageState_.toName" />
						</v-card-text>
						<v-card-actions>
							<v-row justify="center" dense>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbToDlg_styleCloseButtonBlock"
											:color="$_mbToDlg_styleCloseButtonColor"
											:dark="$_mbToDlg_styleCloseButtonDark"
											:depressed="$_mbToDlg_styleCloseButtonDepressed"
											:elevation="$_mbToDlg_styleCloseButtonElevation"
											:large="$_mbToDlg_styleCloseButtonLarge"
											:light="$_mbToDlg_styleCloseButtonLight"
											:outlined="$_mbToDlg_styleCloseButtonOutlined"
											:rounded="$_mbToDlg_styleCloseButtonRounded"
											:small="$_mbToDlg_styleCloseButtonSmall"
											:text="$_mbToDlg_styleCloseButtonFlat"
											@click="$_mbToDlg_close()">
										Close
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-tooltip>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarToDialog',
		data() {
			return {
				componentName_: 'messagebarToDialog',

				messageState_: {},

				show_: null
			}
		},
		computed: {
			// state
			$_mbToDlg_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_mbToDlg_statePageTimeline() {
				const self_ = this;
				return self_.getPageState('timeline')
			},
			$_mbToDlg_statePageTimelineSender() {
				const self_ = this;
				const page_ = self_.$_mbToDlg_statePageTimeline;
				return page_.sender
			},
			// contents / inits
			$_mbToDlg_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbToDlg_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_mbToDlg_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbToDlg_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbToDlg_inits(), 'component')
				}
			},
			$_mbToDlg_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbToDlg_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbToDlg_styleCloseButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbToDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbToDlg_inits(), 'closeButton')
			},
			$_mbToDlg_styleCloseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbToDlg_styleCloseButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbToDlg_styleCloseButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbToDlg_styleCloseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbToDlg_styleCloseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbToDlg_styleCloseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbToDlg_styleCloseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbToDlg_styleCloseButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbToDlg_styleCloseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbToDlg_styleCloseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbToDlg_styleCloseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbToDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		beforeMount() {
			const self_ = this;
			
			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbToDlg_open() {
				const self_ = this;
				self_.show_ = true;
			},
			$_mbToDlg_close() {
				const self_ = this;
				self_.show_ = false;
			}
		}
	}
</script>

<style scoped>
	.row_ {
		min-height: 64px;
	}
	.overflow_ {
		max-width: 50px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
